export const enum SettingKey {
    TeamLastUsed = "TeamLastUsed",
    PlanningPlant = "PlanningPlant",
    MaintenancePlant = "MaintenancePlant",
    WorkCenters = "WorkCenters",
    Language = "Language"
  }